import { useState } from 'react';
import { useForm } from "react-hook-form";
import { queryClient } from '../../..';
import { CreateModal } from "../../../shared/components/Modal";
import { ModalCheckOffline } from '../../../shared/components/Modal/ModalOffline';
import usePostUser from "../hooks/usePostUser";
import { Usuarios } from "../types/UsuariosTipo";
import { FormModalUser } from "./FormModalUser";
import Swal from 'sweetalert2'

interface UserModalProps {
  onCancel: () => void;
  visible: boolean;
}


export function UserModal({ onCancel, visible }: UserModalProps) {
  const { register, handleSubmit, reset, formState: { errors } } = useForm<Usuarios>();
  const [isOffline, setIsOffline] = useState<boolean>(false);

  const { mutate: salvarNovoUsuario, isLoading: LoadingButton} = usePostUser(() => handleCloseLaterSave());

  async function onSubmit(data: Usuarios) {
    !navigator.onLine && Swal.fire({
      title: `Ocorreu um erro`,
      text: `Por favor, verifique sua conexão com a internet e tente novamente`,
      icon: "error",
      position: "center",
      confirmButtonText: "OK",
      confirmButtonColor: "#F27474",
    })

    const { Login, Senha } = data
    if (navigator.onLine) {
      await salvarNovoUsuario({ Login, Senha, Ativo: true });
    }
  }

  function handleCloseLaterSave() {
    onCancel();
    reset();
  }

  return (
    <>
      <CreateModal
        title="Cadastro de Usuário"
        isModalOpen={visible}
        onCancel={onCancel}
        onSubmit={handleSubmit(onSubmit)}
        isLoading={LoadingButton}
      >
        <FormModalUser register={register} errors={errors} />
      </CreateModal> 

      {
        isOffline && <ModalCheckOffline 
          isModalOpen={isOffline}
          closeModal={() => {
            setIsOffline(!isOffline)
            queryClient.invalidateQueries()
            onCancel()
          }}
        />
      }
    </>
  );
}
